import React, { useEffect, useState } from "react";
import api from "../api";
import AdminNavbar from "./AdminNavbar";
import * as XLSX from "xlsx";
import PreLoader from "../components/PreLoader";

export default function AdminRecords() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await api.get("/admin/stats");
      setUsers(res.data.users);
    } catch (err) {
      console.error("Failed to fetch users", err);
    } finally {
      setLoading(false);
    }
  };

  const filteredUsers = users.filter(
    (u) =>
      u.name.toLowerCase().includes(search.toLowerCase()) ||
      u.email.toLowerCase().includes(search.toLowerCase()) ||
      u.collegeId.toLowerCase().includes(search.toLowerCase())
  );

  const exportData = (format) => {
    const data = filteredUsers.map(({ name, email, collegeId, attended }) => ({
      Name: name,
      Email: email,
      CollegeID: collegeId,
      Attendance: attended ? "Attended" : "Not Attended",
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Registrations");

    if (format === "csv") {
      XLSX.writeFile(wb, "fest_records.csv", { bookType: "csv" });
    } else {
      XLSX.writeFile(wb, "fest_records.xlsx", { bookType: "xlsx" });
    }
  };

  const handleExportClick = () => {
    const choice = window.confirm("Download as CSV? Click Cancel for Excel.");
    exportData(choice ? "csv" : "excel");
  };

  return (
    <div className="p-6">
      <AdminNavbar />
      <h2 className="text-2xl font-bold mb-4">All Registrations</h2>

      <div className="flex items-center mb-4">
        <input
          type="text"
          placeholder="Search by name, email or ID"
          className="p-2 border rounded w-full md:w-1/2"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button className="ml-2 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
          Search
        </button>
      </div>

      {loading ? (
        <PreLoader message="Loading records..." />
      ) : (
        <table className="w-full border-collapse mt-4 text-sm">
          <thead>
            <tr className="bg-gray-100">
              <th className="p-2 border">Name</th>
              <th className="p-2 border">Email</th>
              <th className="p-2 border">College ID</th>
              <th className="p-2 border">Attendance</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((user, idx) => (
              <tr key={idx} className="text-center">
                <td className="p-2 border">{user.name}</td>
                <td className="p-2 border">{user.email}</td>
                <td className="p-2 border">{user.collegeId}</td>
                <td className="p-2 border">
                  {user.attended ? "✅ Attended" : "❌ Not Attended"}
                </td>
              </tr>
            ))}
            <tr>
              <td className="p-2 border text-left" colSpan="4">
                <button
                  className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                  onClick={handleExportClick}
                >
                  Export
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
}
